import useSWR from 'swr'
import Head from '@components/common/head'
import { getFeature, getFeatureUsers } from '@data/api/feature'
import { getLatest } from '@data/api/feed'

import ExplorePage from '@pages/explore'

const PER_PAGE = 20

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  featured?: Array<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  featuredUser?: Array<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  latest?: Array<any>
}

const Explore = ({ featured = [], featuredUser = [], latest = []}: Props) => {
  const { data: featuredData } = useSWR('/api/feature/sounds', () => getFeature('Sound'), { fallbackData: featured })
  const { data: featuredUserData } = useSWR('/api/feature/users', getFeatureUsers, { fallbackData: featuredUser })
  const { data: latestData } = useSWR('/api/feed/latest', () => getLatest(PER_PAGE, 1), { fallbackData: latest })
  return (
    <>
      <Head url="/explore" />
      <ExplorePage
        featured={featuredData}
        featuredUser={featuredUserData}
        latest={latestData}
      />
    </>
  )
}

export const getStaticProps = async () => {
  const featured = await getFeature('Sound')
  const featuredUser = await getFeatureUsers()
  const latest = await getLatest(PER_PAGE, 1)

  return {
    props: {
      featured,
      featuredUser,
      latest,
    },
    revalidate: 60,
  }
}

Explore.defaultProps = {
  featured: [],
  featuredUser: [],
  latest: [],
}

export default Explore
